function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.61 12.36c-.282-1.126-1.172-2.016-2.25-2.297-2.016-.563-9.985-.563-9.985-.563s-8.016 0-10.031.563c-1.078.28-1.969 1.171-2.25 2.296-.563 1.97-.563 6.188-.563 6.188s0 4.172.563 6.187a3.127 3.127 0 002.25 2.25c2.015.516 10.031.516 10.031.516s7.969 0 9.984-.516a3.127 3.127 0 002.25-2.25c.563-2.015.563-6.187.563-6.187s0-4.219-.563-6.188zm-14.86 9.984V14.75l6.656 3.797z",
  fill: "#fff"
});

var SvgYouTube = function SvgYouTube(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    width: 36
  }, props), _ref);
};

export default SvgYouTube;